import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { ConfigContext } from '../../contexts/config-context';
import MiscAPI from '../../axios/misc';
import { CategoryIcon, ListingTips, PropertyTypeIcon, PROPERTY_TYPES, TYPES_BY_CATEGORY, sortTypes } from './listing-tips';
import '../../hs-theme.css';
import './new-listing.css';

const CategoryChoice = () => {
    const { t, i18n } = useTranslation(["new_listing"]);
    const { listingType } = useContext(ConfigContext);
    const navigate = useNavigate();
    const typeStep = useRef(null);
    const [picked, setPicked] = useState(null);
    const [types, setTypes] = useState([]);

    useEffect(() => {
        MiscAPI.getPropertyTypeOptions(i18n.language).then(res => setTypes(res.data)).catch(err => console.log(err));
    }, [i18n.language]);

    const pickCategory = (category) => {
        setPicked(category);
        setTimeout(() => typeStep.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
    };

    const allowed = picked && TYPES_BY_CATEGORY[picked.name];
    const typeOptions = sortTypes(types.filter(type => !allowed || allowed.includes(type.id)));

    return (
        <main className='hs-nl-category'>
            <div className='hs-nl-intro'>
                <p className='hs-nl-eyebrow'>{t("form")}</p>
                <h1>{t("publish")}</h1>
                <p>{t("choose")}</p>
            </div>
            <div className='hs-nl-cats'>
                {listingType.map(category => {
                    const on = picked?.name === category.name;
                    return (
                        <button key={category.name} className={`hs-nl-cat ${on ? 'on' : ''}`} aria-pressed={on} onClick={() => pickCategory(category)}>
                            <span className='hs-nl-cat-icon'><CategoryIcon name={category.name} size={28} /></span>
                            <span className='hs-nl-cat-text'>
                                <span className='hs-nl-cat-name'>{t(category.name)}</span>
                                <span className='hs-nl-cat-desc'>{t(`${category.name}_desc`)}</span>
                            </span>
                            <span className='hs-nl-cat-go'>{t(on ? "picked" : "pick")}<span>{on ? '✓' : '→'}</span></span>
                        </button>
                    );
                })}
            </div>
            {picked &&
                <section ref={typeStep} className='hs-nl-type-step'>
                    <div className='hs-nl-type-head'>
                        <span className='hs-nl-step-num'>2</span>
                        <div>
                            <h2>{t(`type_question_${picked.name}`)}</h2>
                            <p>{t("type_hint")}</p>
                        </div>
                    </div>
                    <div className='hs-nl-types'>
                        {typeOptions.map(type => (
                            <button key={type.id} className='hs-nl-type' onClick={() => navigate(`${picked.link}?vrsta=${type.id}`)}>
                                <span className='hs-nl-type-icon'><PropertyTypeIcon id={type.id} size={24} /></span>
                                <span className='hs-nl-type-text'>
                                    <span className='hs-nl-type-name'>{type.label}</span>
                                    {PROPERTY_TYPES[type.id] && <span className='hs-nl-type-desc'>{t(PROPERTY_TYPES[type.id].desc)}</span>}
                                </span>
                            </button>
                        ))}
                    </div>
                </section>}
            <div className='hs-nl-guide'>
                <div className='hs-nl-guide-head'>
                    <span className='hs-nl-guide-icon'>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 11v6M12 7.5h.01" /></svg>
                    </span>
                    <span className='hs-nl-guide-title'>{t("info")}</span>
                    <Link to='/vodic/oglasavanje'>{t("guide")} →</Link>
                </div>
                <ListingTips />
            </div>
        </main>
    );
};

export const NewListing = () => {
    const location = useLocation();

    return (
        <div className='hs hs-nl'>
            <Outlet />
            {location.pathname === '/postavi-oglas' && <CategoryChoice />}
        </div>
    );
};
